import { TeamAccessType, TeamRole } from '@showbie-socrative/socrative-utils';

import localAxios from '../localAxios';
import { teamsMembersURL } from './urls';

export type TeamMember = {
  publicId: string;
  name: string;
  email: string | null;
  role: TeamRole;
  accessLevel: TeamAccessType;
  createdDate: string;
};

export async function getTeamsMembers(teamId: string) {
  const url = teamsMembersURL(teamId);
  const result = await localAxios.get<Array<TeamMember>>(url.href);
  return result.data;
}

export type TeamsMembersData = Awaited<ReturnType<typeof getTeamsMembers>>;
